import React from 'react';
import MelioBrandMark, { MelioBrandLockup } from './brand/MelioBrandMark';

interface MelioLogoProps {
  size?: number;
  className?: string;
  variant?: 'lockup' | 'full' | 'icon';
}

export default function MelioLogo({
  size = 28,
  className = '',
  variant = 'lockup',
}: MelioLogoProps) {
  if (variant === 'full') {
    return <MelioBrandMark variant="full" height={size} className={className} />;
  }
  if (variant === 'icon') {
    return <MelioBrandMark variant="icon" height={size} className={className} />;
  }
  return <MelioBrandLockup iconHeight={size} className={className} />;
}
